import {createSlice} from '@/features/core/store/helpers';

type SettingsState = {
  theme: {
    name: 'light' | 'dark' | 'system';
  };
  ui: {
    sidebarIsOpen: boolean;
  };
};

type SettingsSlice = typeof settingsSlice;

const SETTINGS_STORE_DEFAULT_STATE: SettingsState = {
  theme: {
    name: 'system',
  },
  ui: {
    sidebarIsOpen: true,
  },
};

const settingsSlice = createSlice({
  name: 'settings',
  value: SETTINGS_STORE_DEFAULT_STATE,
  actions: {
    setTheme: (theme: 'light' | 'dark' | 'system') => (state) => {
      state.theme.name = theme;
    },
    toggleSidebar: () => (state) => {
      state.ui.sidebarIsOpen = !state.ui.sidebarIsOpen;
    },
  },
});

export {settingsSlice, SETTINGS_STORE_DEFAULT_STATE};
export type {SettingsState, SettingsSlice};
